import {gql} from '@apollo/client'

export const LOG_POLICY_PAYMENT_VIEW = gql`
  mutation LogPolicyPaymentView($policyId: Int!, $fieldViewed: String!) {
    logPolicyPaymentView(policyId: $policyId, fieldViewed: $fieldViewed) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`
